// @flow
import React from 'react';
import DrawerContentLayout from 'UI/components/templates/DrawerContentLayout';

import useCandidateDataSheet from './hooks/useCandidateDataSheet';
import {
  StyledGpacGeneratorForm,
  useDataSheetDrawerStyles
} from './CandidateDataSheetDrawer.styled';

type CandidateDataSheetDrawerProps = {
  drawerTitle: string,
  draftData: Object,
  candidateDataSheetId: string,
  onClose: () => void,
  onSaveCandidateDataSheet: (candidateDataSheetId: string) => void
};

const CandidateDataSheetDrawer = (props: CandidateDataSheetDrawerProps) => {
  const { onClose, drawerTitle, draftData, candidateDataSheetId, onSaveCandidateDataSheet } = props;

  const classes = useDataSheetDrawerStyles();
  const [dataSheetState, dataSheetActions] = useCandidateDataSheet({
    candidateDataSheetId,
    draftData,
    onSaveCandidateDataSheet,
    onClose
  });

  return (
    <DrawerContentLayout
      containerComponent="div"
      onClose={onClose}
      uiState={{
        isFormLoading: dataSheetState.isFetching || dataSheetState.isFetchingCandidateDataSheetData
      }}
      primaryProps={{
        onClick: dataSheetActions.onSaveClick,
        isSaving: dataSheetState.isSaving,
        disabled: dataSheetState.isSaving,
        initialText: dataSheetState.primaryButtonName
      }}
      title={drawerTitle}
      drawerProps={{ open: true, classes: { paper: classes.drawerLarge } }}
      contentProps={{ className: classes.drawerContent }}
      variant="blue"
    >
      {!!dataSheetState.data && (
        <StyledGpacGeneratorForm
          schema={dataSheetState.data.structure}
          uiSchema={dataSheetState.data.ui}
          httpOptions={dataSheetState.httpOptions}
          showErrorList={false}
          formData={dataSheetState.formData}
          onSubmit={dataSheetActions.save}
          onChange={dataSheetActions.handleOnChange}
          submitRef={dataSheetState.saveButtonRef}
          baseUrl={dataSheetState.baseUrl}
          secondaryBaseUrl={dataSheetState.secondaryBaseUrl}
          noHtml5Validate
          focusOnFirstError
        />
      )}
    </DrawerContentLayout>
  );
};

export default CandidateDataSheetDrawer;
